<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <p-dropdown v-model.trim="form.status" class="dropdown-select" label="Platform Status" name="status" :handler="$v" :formData="form" :options="statusOption" textKey="key" textValue="label"/>
                </b-col>
                <b-col sm="3">
                  <p-input v-model.trim="form.code" label="Platform Code" name="code" :handler="$v" :formData="form"/>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, key) in platformList" :key="key" sm="12" md="4">
        <b-card no-body class="overflow-hidden">
          <b-card-body>
            <b-row>
              <b-col sm="12" md="3">
                <img v-if="item.IconImage" :src="item.IconImage" width="75px" class="platform-image"/>
              </b-col>
              <b-col sm="12" md="9">
                <b-row>
                  <b-col sm="12">
                    <b-row>
                      <b-col sm="9">
                        <p><strong>{{ item.Code }}</strong></p>
                        <p><strong>Display Name:</strong> {{ item.DisplayName }}</p>
                      </b-col>
                      <b-col v-if="checkAccessPrivilege('CMS.GamePlatforms.Update')" sm="3">
                        <b-btn @click="showUpdateModal(item)" class="btn-sm" variant="info"><i class="fa fa-pencil"></i> Edit</b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12">
                    <p>Sort Order: {{ item.Order }}</p>
                    <p>
                      OCMS Platform Status:
                      <b-badge v-if="item.PlatformStatus === 1" variant="success">Enabled</b-badge>
                      <b-badge v-else-if="item.PlatformStatus === 0" variant="danger">Website Mainteannce</b-badge>
                      <b-badge v-else-if="item.PlatformStatus === 2" variant="danger">Gamer Mainteannce</b-badge>
                    </p>
                    <p>
                      Frontend Status:
                      <b-badge v-if="parseInt(item.Status) === 1" variant="success">Enabled</b-badge>
                      <b-badge v-else-if="parseInt(item.Status) === 0" variant="danger">Disabled</b-badge>
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <update-modal v-if="showModal" :show-modal="showModal" :update-data="updateData" :image-field="imageField" @closeModal="closeModal" />
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import UpdateModal from './Update'
import { PInput, PDropdown } from '../../../components'
const _ = require('underscore')

export default {
  name: 'platform-list',
  data () {
    return {
      statusOption: [
        {key: -1, label: 'Disabled'},
        {key: 0, label: 'Website Maintenance'},
        {key: 1, label: 'Enabled'},
        {key: 2, label: 'Game Maintenance'}
      ],
      form: {
        status: null,
        code: ''
      },
      imageField: [],
      showModal: false,
      updateData: {},
      items: []
    }
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  computed: {
    platformList: {
      get: function () {
        let list = { ...this.items }
        const status = this.form.status
        if (status === null) {
        } else if (status !== -1) {
          list = _.filter(list, function (x) { return x.PlatformStatus === status && x.Status === 1 })
        } else if (status === -1) {
          list = _.filter(list, function (x) { return x.Status === 0 })
        }
        let regex = new RegExp(this.form.code.toUpperCase() + '.*')
        return _.chain(list).filter(x => { return this.form.code ? x.Code.toUpperCase().match(regex) : true }).value()
      }
    }
  },
  validations: {
    form: {
      status: {},
      code: {}
    }
  },
  components: {
    UpdateModal,
    PInput,
    PDropdown
  },
  methods: {
    async getImageField () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/v2/platform/imageField')
        this.imageField = data.fields
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async search () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/v2/platform/getAllList?', { headers: { 'Content-Type': 'application/json' } })
        this.items = data
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    showUpdateModal (item) {
      this.showModal = true
      this.updateData = item
    },
    closeModal () {
      this.showModal = false
      this.updateData = {}
      this.search()
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.search()
    this.getImageField()
  }
}
</script>

<style scoped>
.platform-image {
  filter: drop-shadow(2px 4px 6px black);
}
</style>



// WEBPACK FOOTER //
// src/views/game/platforms/PlatformTable.vue